import { GUEST_USER_ID_KEY } from './types';
import type { Identity } from './types';

function generateGuestId(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return `guest-${crypto.randomUUID()}`;
  }
  return `guest-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function getOrCreateGuestId(): string {
  if (typeof localStorage === 'undefined') {
    return generateGuestId();
  }
  const existing = localStorage.getItem(GUEST_USER_ID_KEY);
  if (existing) return existing;
  const created = generateGuestId();
  localStorage.setItem(GUEST_USER_ID_KEY, created);
  return created;
}

export function clearGuestId(): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.removeItem(GUEST_USER_ID_KEY);
}

export function getGuestIdentity(): Identity {
  return {
    kind: 'guest',
    userId: getOrCreateGuestId(),
    email: null,
    displayName: null
  };
}